export class ResponseModel {
    statusCode: string;
    statusMsg: string;
    statusRemark: string;
    data: any;
    displayAlert: boolean;
    timings:any
    length:any
    


    constructor() {
        this.statusCode = '';
        this.statusMsg = '';
        this.statusRemark = '';
        this.data = '';
        this.displayAlert = false;
        this.timings='';
        this.length="";
    }
}

